export default __webpack_public_path__ + "static/media/traffic-cop-icon-19.b02821e9.png";